import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* LIST */

export const listSellersByParams = (data)=>{
return api.post(ENDPOINTS.SELLERS.SEARCH,data);
};

/* DETAILS */

export const getSellerById = (id)=>{
return api.get(ENDPOINTS.SELLERS.BY_ID(id));
};

/* VERIFY */

export const verifySeller = (id)=>{
return api.put(ENDPOINTS.SELLERS.VERIFY(id));
};

/* UNVERIFY */

export const unverifySeller = (id)=>{
return api.put(ENDPOINTS.SELLERS.UNVERIFY(id));
};

/* ACTIVATE */

export const activateSeller = (id)=>{
return api.put(ENDPOINTS.SELLERS.ACTIVATE(id));
};

/* DEACTIVATE */

export const deactivateSeller = (id)=>{
return api.put(ENDPOINTS.SELLERS.DEACTIVATE(id));
};